<template lang="pug">
v-app
  template(v-if="!loading")
    main-header
    v-main
      router-view
    main-footer
    whatsapp-button     
    
  v-sheet.d-flex.justify-center.align-center(
    v-else,
    height="100%",
    width="100%",
    color="transparent"
  )
    v-progress-circular(:size="50", color="primary", indeterminate)
  cookie-banner
</template>

<script>
import MainHeader from "@/components/shell/main-header/Index.vue";
import MainFooter from "@/components/shell/MainFooter.vue";
import WhatsappButton from "@/components/buttons/WhatsappButton";
import CookieBanner from "@/components/widgets/CookieBanner.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      const name = this.informations.name;
      return name ? " - " + name : "";
    },
  },
  watch: {
    name() {
      document.title = `${this.$route.name}${this.name}`;
    },
    $route() {
      document.title = `${this.$route.name}${this.name}`;
    },
  },
  beforeCreate() {
    this.$rest("informations")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  created() {
    document.title = `${this.$route.name}${this.name}`;
  },
  components: {
    MainHeader,
    MainFooter,
    WhatsappButton,
    CookieBanner,
  },
};
</script>

<style>
@import "./style/main.css";
@import "./style/custom-user.css";
@import "./style/custom-vuetify.css";
</style>
